module.exports = __webpack_public_path__ + "img/9788991813281.f44d18e5.jpg";